import React from "react";
import Header from "../layout/header/Header";
import Banner from "../components/home/Banner";
import PopularProducts from "../components/home/PopularProducts";
import Footer from "../layout/footer/Footer";

function Home() {
  return (
    <div>
      <Header />
      <Banner />

      <div className="container mx-auto my-5">
        <PopularProducts />
      </div>
      <img
        src={require("../assets/images/banner/3.jpg")}
        className="w-full object-cover object-center"
      />

      <div className="grid grid-cols-2 container mx-auto">
        <img
          src={require("../assets/images/banner/4.jpg")}
          className="w-full object-cover object-center"
        />
        <img
          src={require("../assets/images/banner/5.jpg")}
          className="w-full object-cover object-center"
        />
      </div>

      <Footer />
    </div>
  );
}

export default Home;
